module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('i', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("I’ve been in the business a long time, so these days I make them come to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They don’t like it much, the lawyers and their satraps, and they like it even less when they compare the pedestrian decor of my office to their own palatial work environments, but if they want me, they put up with it for as long as it takes to hire me. Sometimes it takes quite a while. Like this time, for instance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her brown hair was flecked with gray and crimped into a Brillo bun that reminded me of my grandmother, the one on my father’s side who always made me take off my shoes before coming indoors, the one I didn’t like very much. Her powder blue blouse buttoned to the throat with mother-of-pearl, her navy blue suit jacket covered the entire topology of her torso, and her matching straight skirt was hemmed well below the knee, at the point of maximum frumpiness. Her shoes were as sensible as snow tires; the eyeglasses on her nose made her look like a jungle bird on the brink of capture. Some people think women lawyers are like Ally McBeal. Those people have never met one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t have an ounce of fat or of irony either. Whatever had brought her to my place of business was deadly serious, in fact, or so I was urged to believe by her demeanor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We faced each other like bookends in the reference section. “Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced at the calendar, the one labeled "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARD BOILED")]), _vm._v(". “Ms. Sundstrom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m pleased to meet you,” she said without meaning it, and extended a ringless hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Same here,” I said as we shook. Her flesh was as cold as custard. Her knuckles were as faceted as fine jewelry. “And please call me Marsh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Karla.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With a "), _c('i', [_vm._v("K")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet your father was Karl and you were an only child.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Elementary, my dear Ms. Sundstrom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a twitch of indecision that no doubt questioned my sobriety, she gestured toward a chair. “May I sit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m nothing if not magnanimous. “Of course.” I gave her credit for not trying to dust it off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She squirmed this way and that, trying to find a comfortable angle of repose, but it would have been easier to find a four-leaf clover in the carpet. Her focus on her own contentment was such that she didn’t even respond to the painting on the wall at my back. It was just as well. She probably viewed Klee as random and racy and therefore profane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She clasped her hands and launched her pitch. “Before we get into details, I should mention that the engagement I’m going to describe will occupy virtually all of your time, at least periodically. Are you in a position to take on such a task, assuming we formalize the arrangement?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mind glided across my active case list the way a seagull glides across a landfill. “As it happens, I’m between projects at the moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not according to my accountant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She frowned until she deciphered it. “Yes. Of course. Well, I’m sure the hiatus is only temporary. What are your rates, if I may ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I employed the fudge factor I use when the job seems tedious or the client obnoxious. “Sixty dollars an hour plus expenses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She raised a well-penciled black brow. “That seems rather high.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crossed my arms and propped my feet on the desk, assuming my own favorite angle of repose. “You’re a lawyer and you’re here on behalf of a client, am I right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s correct.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So your meter is running, as they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I … yes. If you want to put it that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’ll charge whatever you’re charging.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She colored and looked away. “That wouldn’t be at all appropriate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? I’m the one loaded with free time. Seems to me it’s a seller’s market.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She readjusted her position and recrossed her shapeless legs. When she was adequately arranged, she tugged so hard on her skirt I was afraid she was going to rip it off. “You seem rather out of sorts this morning, Mr. Tanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you seem rather dour and reluctant, Ms. Sundstrom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We locked sight lines until we decided to mutually disengage. “I find a certain reserve helps me be more effective in my work,” Ms. Sundstrom acknowledged finally, though not without embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As do I,” I countered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Plus my expertise is in personal services contracts and intellectual-property issues. I’ve never dealt with a potentially violent situation before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whereas I deal with such situations all the time,” I exaggerated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took the bait. “I suppose that’s why I’m here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I suppose that’s why I charge sixty bucks an hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a philosophical struggle that seemed to be unique to her experience, Ms. Sundstrom bowed in homage to my trump. Then she consulted a watch that was thinner than her wrist but not much. Then she looked up. “Shall I proceed, or have we decided we’re terminally incompatible?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laughed because I assumed she’d made a joke. “You tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m prepared to go forward.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So am I. Though not necessarily all the way, since this is our first date.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips wrinkled and her nose lifted. “Men frequently assume I’ll be undone by double entendre. I have four older brothers; I’ve yet to hear a scurrile reference that wasn’t inflicted upon me with regularity from about the age of nine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I was the one who blushed. “I apologize.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For being like all the other men in your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have no men in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess that’s what four brothers will do for you. Shall we get down to business?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please.” She retrieved her briefcase from the floor and extracted what looked like a contract. “I have a client who’s in danger, Mr. Tanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of danger?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her life has been threatened. Several times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Threatened by whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The threats were anonymous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have there been actual attempts to harm her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet. Thank God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you take the threats seriously.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded. “More important, so does my client.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chandelier Wells.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now my brow was the one that elevated. “The writer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My hourly rate just tripled.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I finally provoked an infinitesimal grin. “I take it you’re familiar with her work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not her work; just her reputation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, well, whatever you may have read or heard about her, shall we say, personal peccadilloes, Chandelier Wells is the most successful novelist in San Francisco, Danielle Steel and Richard North Patterson not excluded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I’m afraid success comes at a price.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The price in this instance is danger.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For some reason I looked at my sagging couch and my faded carpet and my peeling paint and wondered how long it would be till I could stop taking on troubles for a living. “What does Ms. Wells want from me, exactly?” I asked before I’d answered my question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like all good lawyers, Ms. Sundstrom was ready with a succinct answer to a predictable inquiry. “She wants you to serve as her bodyguard until the source of the threats is identified and neutralized. The precise nature of the relationship is spelled out in this document I’ve prepared for your signature.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Ms. Sundstrom placed the document on the desk, I pushed back my chair and stood up. “Sorry to disappoint you, but I don’t do that kind of work. I don’t even go to those kinds of movies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Sundstrom stayed seated. “Please hear me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why should I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because Chandelier asked for you by name. And because she doesn’t take no for an answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I did a partial pirouette. “Take a look, Ms. Sundstrom. I don’t have enough muscles to make anyone think twice, I have only one gun and I’m not sure where it is at the moment, I’ve never attended defensive-driving school or counterinsurgency training or even learned CPR, and I don’t like being cooped up with strangers even on a bus ride. You’d better get a new boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shook her head. “That’s not an option, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But why me?” I asked, more plaintively than I intended. “There are all kinds of mammoth security firms that can guard Ms. Wells day and night and she won’t even know it’s happening. I can give you names if you want. I’ll even make you an appointment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was shaking her head before I finished my screed. “Sorry, Mr. Tanner. I don’t want names, I want you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still don’t understand why.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because you come highly recommended.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Millicent Colbert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sank back to my chair, heavily and disconsolately, and propped my head with my hands. “How does Ms. Wells know Mrs. Colbert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They have children in the same preschool.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laurel Hill.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe that’s the one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Millicent told Chandelier I could take care of her problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, she did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sighed and closed my eyes. It began to look like I was about to guard a body.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f596f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 69
// module chunks = 0